import SectionContact from "./section-contact";
import SectionLocation from "./section-location";
import SectionProfile from "./section-profile";
import SectionApplicantVerification from "./section-applicant-verification";
import SectionApplicantCoverLetter from "./section-applicant-cover-letter";
import { useSelector } from "react-redux";

function SectionEmployersCandidateSidebar({ type, applicantDetailInfo, coverLetterText, setActiveTab }) {
  const { role_type } = useSelector((state)=>state.menu);
  const isNotEmployee = applicantDetailInfo?.workerType && applicantDetailInfo?.workerType !== "Employee";
  return (
    <>
      <div className="side-bar-2 rightSidebar">
        {type === "1" ? (
          <>
            <div className="twm-s-map mb-5">
              <SectionLocation applicantDetailInfo={applicantDetailInfo} />
            </div>
            <div className="side-bar">
              <div className="twm-s-info2-wrap">
                <div className="twm-s-info2 twm-tabs-style-2">
                  <ul className="nav nav-tabs" id="myTab2" role="tablist">
                    {/*Login Candidate*/}
                    
                    {
                      isNotEmployee && 
                      <>
                        <li className="nav-item" style={{ width: "100%" }}>
                        <button
                          className={`nav-link ${isNotEmployee ? 'active' : ''}`}
                          data-bs-toggle="tab"
                          data-bs-target="#applicant-document"
                          type="button"
                          style={{ width: "100%" }}
                          onClick={() => setActiveTab('document')}
                        >
                          <i className="fas fa-user-tie" />
                          Documents
                        </button>
                      </li>
                      {/*Login Employer*/}
                      <li className="nav-item" style={{ width: "100%" }}>
                        <button
                          className="nav-link"
                          data-bs-toggle="tab"
                          data-bs-target="#applicant-certificates"
                          type="button"
                          style={{ width: "100%" }}
                          onClick={() => setActiveTab('certificate')}
                        >
                          <i className="fas fa-award" />
                          Certificates
                        </button>
                      </li>
                      </>
                    }
                    {/* {
                      !role_type.includes('ROLE_SEEKER_USER_ADMIN') && 
                      <li className="nav-item" style={{ width: "100%" }}>
                      <button
                        className="nav-link"
                        data-bs-toggle="tab"
                        data-bs-target="#applicant-notes"
                        type="button"
                        style={{ width: "100%" }}
                      >
                        <i className="fas fa-book-open" />
                        Notes
                      </button>
                    </li>
                    } */}
                    {
                      // !role_type.includes('ROLE_SEEKER_USER_ADMIN') && 
                      <li className="nav-item" style={{ width: "100%" }}>
                      <button
                        className={`nav-link ${isNotEmployee ? '' : 'active'}`}
                        data-bs-toggle="tab"
                        data-bs-target="#applicant-resume-cover-letter"
                        type="button"
                        style={{ width: "100%" }}
                      >
                        <i className="fas fa-file" />
                        Resume / Cover Letter
                      </button>
                    </li>
                    }
                    <li className="nav-item" style={{ width: "100%" }}>
                      <button
                        className="nav-link"
                        data-bs-toggle="tab"
                        data-bs-target="#applicant-chat"
                        type="button"
                        style={{ width: "100%" }}
                      >
                        <i className="fas fa-comment" />
                          Chat
                      </button>
                    </li>
                    
                  </ul>
                </div>
              </div>
            </div>
            <div className="twm-s-info-wrap mb-5">
              <SectionProfile applicantDetailInfo={applicantDetailInfo} isNotEmployee={isNotEmployee} />
            </div>
            {
              isNotEmployee && 
               <div className="twm-s-info-wrap mb-5">
                <SectionApplicantVerification applicantDetailInfo={applicantDetailInfo} />
              </div>
            }
           
          </>
        ) : (
          <>
            <div className="twm-s-map mb-5">
              <SectionProfile />
            </div>
            <div className="twm-s-info-wrap mb-5">
              <SectionLocation />
            </div>
          </>
        )}
        {/* <div className="twm-s-contact-wrap mb-5">
          <SectionContact />
        </div> */}
      </div>
    </>
  );
}

export default SectionEmployersCandidateSidebar;
